import React, { Component } from 'react'
import styles from './LinkedInput.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose, faLink, faLinkSlash } from '@fortawesome/free-solid-svg-icons'

class LinkedInput extends Component {
    constructor(props) {
        super(props) 

        this.linkRef = React.createRef()
        this.state = {
            isOpened: props.linkValue ? true : false
        }
    }

    handleRemoveLink = () => {
        if (this.props.onRemoveLink) {
            this.props.onRemoveLink()
        }

        this.setState({
            isOpened: false
        })
    }

    handleOpenLink = async () => {
        if (this.linkRef) {
            this.linkRef.current.focus()
        }

        await this.setState({
            isOpened: true
        })

        if (this.props.onAddLink) {
            this.props.onAddLink()
        }
    }

    renderLinkIcon = () => {
        if (this.props.hideAddLinkButton) {
            return
        }

        if(!this.state.isOpened) {
            return (
                <div 
                    className={`${styles['link-icon']} ${this.props.toggleLinkClassName || ''}`}
                    onClick={this.handleOpenLink}
                >
                    <FontAwesomeIcon  
                        icon={faLink} 
                        title="Add Link"
                    />
                </div>
            )
        }

        return (
            <div 
                className={`${styles['link-icon']} ${this.props.toggleLinkClassName || ''}`}
                onClick={this.handleRemoveLink}
            >
                <FontAwesomeIcon 
                    icon={faLinkSlash} 
                    title="Remove Link"
                />
            </div>
        )
    }

    renderRemoveButton = () => {
        if (this.props.hideRemoveButton) {
            return
        }

        const render = (
            <div 
                className={this.props.removeButtonClassName}
                onClick={this.props.onRemove}
            >
                <FontAwesomeIcon  
                    className={styles['delete-icon']}
                    icon={faClose}
                />
            </div>
        )
        
        if (typeof this.props.showRemoveButton !== 'boolean') {
            return render
        }

        if (this.props.showRemoveButton) {
            return render
        }

        return null 
    }
    
    render() {
        return (
            <>
                <div className={`${styles['linked-input']} ${this.props.className || ''}`} ref={this.props.innerRef}>
                    <div className={styles['input']}>
                        <input 
                            className={this.props.inputClassName || ''}
                            type="text" 
                            placeholder={this.props.placeholder} 
                            value={this.props.value} 
                            onChange={this.props.onChange}
                            maxLength={this.props.maxLength}
                        />
                        <div className={this.props.hideAddLinkButton && this.props.hideRemoveButton ? '' : styles['padding-right']}>
                            { this.renderLinkIcon() }
                            { this.renderRemoveButton() }
                        </div>
                    </div>
                    {
                        this.props.inputErrorMessage 
                            && <div className={`${styles['input-error']} text-xs text-red-500`}>{this.props.inputErrorMessage}</div>
                    } 
                    <div className={`${styles['input-link']} ${this.state.isOpened ? '' : 'hidden'}`}>
                        <label className="font-medium">{this.props.linkLabel || 'Link URL'}</label>
                        <input 
                            className="input-link form-control"
                            type="text" 
                            placeholder={this.props.linkPlaceholder} 
                            value={this.props.linkValue} 
                            onChange={this.props.onLinkChange}
                            ref={this.linkRef}
                            readOnly={this.props.readOnlyLinkInput}
                        />
                        {
                            this.props.linkInputErrorMessage
                                && <div className={`text-xs mt-2 text-red-400`}>{this.props.linkInputErrorMessage}</div>
                        }
                    </div>
                </div>
            </>
        )
    }
}

LinkedInput.defaultProps = {
    hideAddLinkButton: false,
    hideRemoveButton: false,
    readOnlyLinkInput: false
}

export default React.forwardRef((props, ref) => <LinkedInput innerRef={ref} { ...props } />)